module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-02-881998ca647d3165bf2a87c0298cac00.jpg";